import { entity as E } from "./schema.js";
export const retail = {
"BB-RTL-01": [
E("rtl_product", "Retail product", "A commercial product grouping independently stockable variants.", `product_code|CODE(50)|Retailer product reference
name|TEXT(200)|Merchandise name
category_code|CODE(60)|Retail merchandise category
brand_party_id|>pty_party.party_id?|Brand-owner party`, ["product_code"], "Product grouping is distinct from the shared stock item and its unit of measure."),
E("rtl_variant", "Retail product variant", "A sellable variant explicitly mapped to a shared inventory item.", `product_id|>rtl_product.id|Commercial product
item_id|>inv_item.item_id|Stock item
variant_code|CODE(40)|Product variant identifier
selling_unit|CODE(16)|Unit offered for sale
barcode|CODE(60)?|Optional externally issued barcode`, ["product_id,variant_code", "item_id"], "Barcode is not assumed globally unique without a declared scheme and validation."),
E("rtl_assortment", "Retail assortment", "A dated assortment for a sales channel or store group.", `assortment_code|CODE(40)|Assortment reference
channel_code|CODE(40)|Sales channel or store group
valid_from|DATE|Assortment start
valid_to|DATE?|Assortment end`, ["assortment_code,valid_from"], "Channels and store groups need explicit local vocabulary."),
E("rtl_assortment_item", "Assortment membership", "A variant offered within an assortment.", `assortment_id|>rtl_assortment.id|Assortment
variant_id|>rtl_variant.id|Sellable variant
rank|INTEGER|Display priority
status|CODE(20)|Planned, active or delisted`, ["assortment_id,variant_id"], "Delisting affects offer availability and does not erase inventory history.")
],
"BB-RTL-02": [
E("rtl_supplier_offer", "Retail supplier offer", "A supplier's commercial offer for an inventory item.", `supplier_id|>sup_account.supplier_id|Shared supplier account
item_id|>inv_item.item_id|Offered item
supplier_item_code|CODE(60)|Supplier catalogue reference
currency|CODE(3)|Offer currency
minimum_order|QTY|Minimum purchase quantity
purchase_uom|CODE(16)|Unit for minimum quantities and supplier unit prices`, ["supplier_id,supplier_item_code"], "Unit conversion and supplier-item mapping require explicit agreement."),
E("rtl_supplier_terms", "Supplier terms version", "Effective commercial terms for a supplier offer.", `offer_id|>rtl_supplier_offer.id|Supplier item offer
version|INTEGER|Terms revision
valid_from|DATE|Effective start
unit_price|MONEY|Price in offer currency
lead_days|INTEGER|Agreed lead time
payment_terms|CODE(40)|Payment terms reference`, ["offer_id,version"], "Lead time is a commitment estimate; delivery performance is measured separately."),
E("rtl_supplier_performance", "Supplier delivery assessment", "A period assessment of delivery against an agreed offer.", `offer_id|>rtl_supplier_offer.id|Assessed supplier item
period_end|DATE|Measurement period end
deliveries|INTEGER|Assessed delivery count
on_time_deliveries|INTEGER|On-time delivery count
measurement_rule|TEXT(160)|Definition and data-source reference`, ["offer_id,period_end"], "On-time count cannot exceed total deliveries and needs a consistent measurement rule.")
],
"BB-RTL-03": [
E("rtl_purchase_order", "Retail purchase order", "A purchasing instruction to a supplier account.", `supplier_id|>sup_account.supplier_id|Supplier account
order_number|CODE(50)|Purchase order reference
ordered_on|DATE|Order date
currency|CODE(3)|Order currency
status|CODE(20)|Draft, sent or closed`, ["order_number"], "Purchase orders are distinct from supplier offers and later invoice obligations."),
E("rtl_purchase_line", "Retail purchase line", "A replenishment item ordered under commercial terms.", `order_id|>rtl_purchase_order.id|Purchase order
line_no|INTEGER|Order sequence
terms_id|>rtl_supplier_terms.id|Agreed supplier terms version
quantity|QTY|Ordered quantity
uom|CODE(16)|Order unit
expected_on|DATE|Expected receipt date`, ["order_id,line_no"], "Order currency must be reconciled with the referenced terms currency."),
E("rtl_purchase_receipt", "Retail purchase receipt", "A partial delivery against a purchase-order line.", `line_id|>rtl_purchase_line.id|Purchase line
receipt_reference|CODE(60)|Goods receipt identifier
movement_id|>inv_movement.movement_id|Stock receipt movement
received_at|INSTANT|Receipt timestamp
quantity|QTY|Received quantity in order unit`, ["receipt_reference"], "Overreceipts require explicit tolerance approval.")
],
"BB-RTL-04": [
E("rtl_receiving_task", "Warehouse receiving task", "A receipt handling task at a shared warehouse location.", `receipt_id|>rtl_purchase_receipt.id|Goods receipt
location_id|>inv_location.stock_location_id|Receiving location
task_reference|CODE(50)|Warehouse work reference
status|CODE(20)|Ready, active or completed`, ["task_reference"], "Receiving tasks reference shared stock movements and locations."),
E("rtl_putaway", "Warehouse put-away task", "A directed movement from receiving to a storage location.", `receiving_id|>rtl_receiving_task.id|Receiving task
task_no|INTEGER|Put-away task sequence
destination_id|>inv_location.stock_location_id|Destination location
quantity|QTY|Quantity directed
completed_at|INSTANT?|Completion time`, ["receiving_id,task_no"], "Completion requires a reconciled movement rather than only a task status change."),
E("rtl_pick_task", "Warehouse pick task", "Work to fulfill a shared stock reservation.", `reservation_id|>inv_reservation.reservation_id|Stock reservation
task_reference|CODE(50)|Pick work reference
location_id|>inv_location.stock_location_id|Pick location
picked_quantity|QTY|Confirmed picked quantity
status|CODE(20)|Ready, picked or short`, ["task_reference"], "Short picks must update fulfillment explicitly without inventing stock."),
E("rtl_pack_unit", "Warehouse packing unit", "A labeled handling unit containing a pick task's output.", `pick_task_id|>rtl_pick_task.id|Source pick task
package_reference|CODE(60)|Packing unit identifier
package_type|CODE(30)|Carton, pallet or bag
packed_quantity|QTY|Contained quantity
packed_at|INSTANT|Packing timestamp`, ["package_reference"], "Consolidated mixed-item packages require child content rows in a local extension.")
],
"BB-RTL-05": [
E("rtl_stock_policy", "Retail stock policy", "An effective policy for holding an item at a location.", `item_id|>inv_item.item_id|Shared stock item
location_id|>inv_location.stock_location_id|Shared location
valid_from|DATE|Policy start
safety_quantity|QTY|Target safety stock
maximum_quantity|QTY|Target maximum stock
uom|CODE(16)|Inventory unit`, ["item_id,location_id,valid_from"], "Policy targets do not replace stock balances derived from accepted movements."),
E("rtl_stock_count", "Retail stock count", "A count session at a retail storage location.", `location_id|>inv_location.stock_location_id|Counted location
count_reference|CODE(50)|Count session reference
counted_at|INSTANT|Snapshot time
status|CODE(20)|Open, reviewed or posted`, ["count_reference"], "Concurrent movements must be reconciled to the count cutoff."),
E("rtl_stock_count_line", "Retail count line", "Observed stock and its approved adjustment reference.", `count_id|>rtl_stock_count.id|Count session
line_no|INTEGER|Count line
item_id|>inv_item.item_id|Counted item
lot_id|>inv_lot.lot_id?|Counted lot
quantity|QTY|Observed quantity in the counted item base inventory unit
adjustment_id|>inv_movement.movement_id?|Approved variance movement`, ["count_id,line_no"], "Count observations are retained even if no adjustment is approved.")
],
"BB-RTL-06": [
E("rtl_demand_observation", "Retail demand observation", "A time-bucketed demand measure for an item and location.", `policy_id|>rtl_stock_policy.id|Item-location stock policy
period_start|DATE|Observation start
period_end|DATE|Observation end
sold_quantity|QTY|Observed sales demand
lost_quantity|QTY?|Estimated unavailable demand`, ["policy_id,period_start"], "Estimated lost sales must remain distinguishable from measured sales."),
E("rtl_replenishment_run", "Replenishment planning run", "A versioned planning calculation with an explicit horizon.", `run_reference|CODE(50)|Planning run identifier
calculated_at|INSTANT|Calculation timestamp
horizon_end|DATE|Planning horizon
method_reference|TEXT(160)|Rule or forecast version`, ["run_reference"], "Forecast output is a planning proposal, not an automatic purchasing commitment."),
E("rtl_replenishment_proposal", "Replenishment proposal", "Suggested supply for a stock policy within a planning run.", `run_id|>rtl_replenishment_run.id|Planning run
policy_id|>rtl_stock_policy.id|Item-location policy
quantity|QTY|Suggested quantity
required_on|DATE|Suggested availability date
purchase_line_id|>rtl_purchase_line.id?|Approved resulting order line
status|CODE(20)|Proposed, accepted or rejected`, ["run_id,policy_id"], "Acceptance must reconcile existing supply and minimum order constraints.")
],
"BB-RTL-07": [
E("rtl_sales_context", "Retail order channel", "Retail channel details attached to a shared sales order.", `order_id|>sal_order.order_id|Shared sales order
channel_code|CODE(40)|Store, web or partner channel
external_reference|CODE(80)|Channel-scoped order reference
placed_at|INSTANT|Customer order time`, ["order_id", "channel_code,external_reference"], "The shared sales model retains customer, order, line and monetary definitions."),
E("rtl_line_price", "Retail line price evidence", "The price and discount decision applied to a sales line.", `order_line_id|>sal_order_line.order_line_id|Sales line
revision|INTEGER|Pricing revision
list_price|MONEY|Undiscounted unit price
discount_amount|MONEY|Unit discount
currency|CODE(3)|Price currency
pricing_reference|TEXT(120)|Approved price decision source`, ["order_line_id,revision"], "Tax-inclusive versus tax-exclusive treatment must be declared by the implementation."),
E("rtl_order_status_event", "Retail order status", "Channel-facing status history of a retail order.", `context_id|>rtl_sales_context.id|Retail order context
event_no|INTEGER|Status sequence
status|CODE(30)|Placed, accepted, picking, dispatched or cancelled
occurred_at|INSTANT|Effective timestamp
reason|TEXT(300)?|Status-change reason`, ["context_id,event_no"], "Channel status must reconcile with fulfillment and payment evidence.")
],
"BB-RTL-08": [
E("rtl_delivery", "Retail delivery", "A carrier delivery associated with a shared shipment.", `shipment_id|>sal_shipment.shipment_id|Shared shipment
carrier_id|>pty_party.party_id|Delivery carrier
tracking_reference|CODE(80)|Carrier tracking identifier
promised_on|DATE|Customer delivery promise
status|CODE(20)|Prepared, collected, delivered or exception`, ["carrier_id,tracking_reference"], "Tracking identifiers are scoped to carriers."),
E("rtl_delivery_package", "Delivery package assignment", "A packed warehouse unit assigned to a carrier delivery.", `delivery_id|>rtl_delivery.id|Carrier delivery
package_id|>rtl_pack_unit.id|Packed unit
loaded_at|INSTANT|Handover timestamp
handover_reference|TEXT(120)|Carrier acceptance evidence`, ["delivery_id,package_id"], "A packing unit cannot be simultaneously assigned to incompatible active deliveries."),
E("rtl_delivery_event", "Retail delivery tracking event", "A carrier-sourced tracking update.", `delivery_id|>rtl_delivery.id|Tracked delivery
event_no|INTEGER|Event sequence
occurred_at|INSTANT|Carrier event time
event_kind|CODE(30)|Collected, in_transit, attempted or delivered
evidence_reference|TEXT(200)?|Delivery evidence reference`, ["delivery_id,event_no"], "A delivery assertion retains its carrier evidence and can be disputed.")
],
"BB-RTL-09": [
E("rtl_return_request", "Retail return request", "A customer's request to return an original sale line.", `order_line_id|>sal_order_line.order_line_id|Original sale line
return_reference|CODE(60)|Return authorization reference
requested_on|DATE|Request date
requested_quantity|QTY|Quantity requested
reason|CODE(40)|Customer return reason`, ["return_reference"], "A request is not evidence of goods receipt or entitlement to credit."),
E("rtl_return_inspection", "Returned-goods inspection", "An observed return condition and approved disposition.", `request_id|>rtl_return_request.id|Return request
inspection_no|INTEGER|Inspection sequence
received_quantity|QTY|Observed returned quantity
condition_code|CODE(40)|Goods condition
disposition|CODE(30)|Restock, repair, scrap or supplier_return
inspected_at|INSTANT|Inspection timestamp`, ["request_id,inspection_no"], "Restocking requires a corresponding inventory movement."),
E("rtl_exchange_credit", "Return resolution", "An approved exchange or credit for inspected returned goods.", `inspection_id|>rtl_return_inspection.id|Supporting inspection
resolution_no|INTEGER|Resolution sequence
replacement_line_id|>sal_order_line.order_line_id?|Replacement sale line
credit_reference|TEXT(120)?|Approved credit document
amount|MONEY|Credit amount
currency|CODE(3)|Credit currency`, ["inspection_id,resolution_no"], "A resolution must explicitly select exchange, credit or both without duplicate reimbursement.")
],
"BB-RTL-10": [
E("rtl_price_list", "Retail price list", "A currency-specific price list for a selling channel.", `list_code|CODE(40)|Price list identifier
channel_code|CODE(40)|Applicable channel
currency|CODE(3)|Pricing currency
valid_from|DATE|List effective start`, ["list_code,valid_from"], "Price list applicability must specify market and tax treatment locally."),
E("rtl_price", "Retail item price", "A variant price effective for a dated interval.", `list_id|>rtl_price_list.id|Price list
variant_id|>rtl_variant.id|Sellable variant
starts_on|DATE|Price interval start
ends_on|DATE?|Price interval end
unit_price|MONEY|Price in list currency`, ["list_id,variant_id,starts_on"], "Overlapping active price intervals need an explicit precedence rule."),
E("rtl_promotion", "Retail promotion", "A dated discount campaign with reviewed combination rules.", `promotion_code|CODE(50)|Promotion reference
name|TEXT(160)|Campaign label
starts_at|INSTANT|Promotion start
ends_at|INSTANT|Promotion end
combination_rule|TEXT(500)|Whether and how discounts can combine`, ["promotion_code"], "Promotion rules are descriptive; no executable pricing engine is bundled."),
E("rtl_promotion_item", "Promoted variant", "A discount condition for a variant in a promotion.", `promotion_id|>rtl_promotion.id|Promotion
variant_id|>rtl_variant.id|Eligible variant
discount_percent|PCT|Percentage reduction
minimum_quantity|QTY|Quantity threshold`, ["promotion_id,variant_id"], "Discount bounds and rounding require validation before use.")
],
"BB-RTL-11": [
E("rtl_payment_attempt", "Retail payment attempt", "A tokenized processor request for payment of a sales order.", `order_id|>sal_order.order_id|Sales order
processor|CODE(40)|Payment service provider
attempt_reference|CODE(80)|Provider request identifier
amount|MONEY|Requested amount
currency|CODE(3)|Payment currency
status|CODE(20)|Pending, authorized, captured or failed`, ["processor,attempt_reference"], "No PAN, CVV or secret payment credentials are modeled."),
E("rtl_tender_event", "Retail tender event", "A capture, refund or reversal recorded by a processor.", `attempt_id|>rtl_payment_attempt.id|Payment attempt
event_reference|CODE(80)|Provider event identifier
event_kind|CODE(20)|Capture, refund or reversal
amount|MONEY|Event magnitude in attempt currency
occurred_at|INSTANT|Provider event timestamp`, ["attempt_id,event_reference"], "Refunds and reversals are separate immutable events."),
E("rtl_settlement", "Retail processor settlement", "A payment provider settlement statement.", `processor|CODE(40)|Provider identity
statement_reference|CODE(80)|Statement identifier
settled_on|DATE|Settlement date
currency|CODE(3)|Settlement currency
net_amount|MONEY|Net amount after fees`, ["processor,statement_reference"], "Settlement differences and fees require explicit reconciliation."),
E("rtl_settlement_item", "Retail settlement allocation", "A tender event allocated to a processor settlement.", `settlement_id|>rtl_settlement.id|Settlement statement
tender_event_id|>rtl_tender_event.id|Allocated tender event
gross_amount|MONEY|Gross settlement value
fee_amount|MONEY|Assessed processor fee`, ["settlement_id,tender_event_id"], "Allocations must reconcile to the statement net amount without double counting.")
],
"BB-RTL-12": [
E("rtl_landed_cost", "Merchandise landed cost", "Purchase, freight or other cost attributed to a goods receipt.", `receipt_id|>rtl_purchase_receipt.id|Costed receipt
line_no|INTEGER|Cost component
cost_kind|CODE(30)|Purchase, freight, handling or duty
amount|MONEY|Cost amount
currency|CODE(3)|Cost currency`, ["receipt_id,line_no"], "Capitalization and tax recoverability are explicit accounting policy decisions."),
E("rtl_stock_valuation", "Retail inventory valuation", "A dated item-location inventory valuation with its method.", `item_id|>inv_item.item_id|Valued stock item
location_id|>inv_location.stock_location_id|Stock location
as_of|DATE|Valuation date
method|CODE(30)|Reviewed valuation method
quantity|QTY|Valued quantity in the item base inventory unit
amount|MONEY|Valuation amount
currency|CODE(3)|Valuation currency`, ["item_id,location_id,as_of,method"], "Valuation must reconcile to accepted movements; no cost-flow method is imposed."),
E("rtl_finance_allocation", "Retail finance allocation", "A ledger journal attributed to a retail operational source.", `journal_id|>fin_journal.journal_id|Approved shared ledger journal
source_reference|CODE(100)|Purchase, sale, valuation or settlement identity
source_kind|CODE(30)|Operational source classification
amount|MONEY|Allocated journal amount
currency|CODE(3)|Allocation currency`, ["journal_id,source_reference,source_kind"], "Sales margins and payable/receivable balances derive from reconciled source and ledger entries.")
]
};
